<main>
  <loading-overlay [isLoading]="isLoading()" />
  <p-confirmDialog />

  <header>
    <div class="headline">
      <h1>
        {{ 'DyeingDashboardMachineDetailsPage.Title' | translateWF: 'Dyeing Machine' }} : {{ assetId }}
        @if (currentMachine()) {
          <span class="text-sm text-gray-500">- {{ machineStatus() }}</span>
        }
      </h1>
    </div>
    <div class="buttons">
      <p-button label="Back to Dashboard" variant="outlined" (click)="redirectDashboard()" />
    </div>
  </header>

  <div class="content">
    <div class="col">
      <!-- First Run Warning -->
      @if (showFirstRunWarning()) {
        <div class="mb-6 bg-orange-50 border-l-4 border-orange-500 p-4 rounded-lg shadow">
          <div class="flex items-center">
            <i class="pi pi-exclamation-triangle text-orange-500 text-xl mr-3"></i>
            <div>
              <p class="text-orange-800 font-semibold">First Production card from {{ workOrderNumber() ? workOrderNumber() : 'this Work Order' }}!</p>
              <p class="text-orange-700 text-sm mt-1">This is the first dyeing cycle for quality review. Other batches should wait for approval before proceeding.</p>
            </div>
          </div>
        </div>
      }

      <!-- Current Cycle Information -->
      @if (currentMachine()?.currentDyeingCycle) {
        <p-panel>
          <ng-template pTemplate="header">
            <h3 class="text-lg font-semibold flex items-center gap-2">
              <i class="pi pi-sync text-blue-600"></i>
              Current Dyeing Cycle
            </h3>
          </ng-template>
          <ng-template pTemplate="icons">
            @if (showEndCycleButton()) {
              <p-button label="End Cycle" severity="warn" (click)="confirmEndCycle()" />
            }

            @if (showHardStopButton()) {
              <p-button label="Hard Stop" severity="danger" (click)="confirmHardStop()" />
            }

            @if (showUnloadButton()) {
              <p-button label="Unload Machine" severity="info" (click)="confirmUnload()" />
            }

            @if (showHardApproveButton()) {
              <p-button label="Hard Approve" severity="danger" (click)="confirmHardApprove()" />
            }
          </ng-template>
          <p-card>
            <div class="grid-2">
              <div>
                <p class="text-sm text-gray-500">Cycle Number:</p>
                <p class="text-base font-semibold text-gray-800">{{ currentMachine()!.currentDyeingCycle!.number }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-500">Cycle #:</p>
                <p class="text-base font-semibold text-gray-800">{{ currentMachine()!.currentDyeingCycle!.cycleNumber }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-500">Start Time:</p>
                <p class="text-base font-semibold text-gray-800">{{ currentMachine()!.currentDyeingCycle!.startTime | date: 'short' }}</p>
              </div>
              @if (currentMachine()!.currentDyeingCycle!.endTime) {
                <div>
                  <p class="text-sm text-gray-500">End Time:</p>
                  <p class="text-base font-semibold text-gray-800">{{ currentMachine()!.currentDyeingCycle!.endTime | date: 'short' }}</p>
                </div>
              }
            </div>
          </p-card>
        </p-panel>
      }

      <!-- Search Section (StandBy Only) -->
      @if (showSearchSection()) {
        <p-panel [header]="'DyeingMachineDetailsPage.SelectProductionCard' | translateWF: 'Select Production Card'">
          <p-card>
            <div class="flex items-center gap-4">
              <p-autocomplete
                class="flex-1"
                styleClass="w-full"
                #productionCardSearch="cslServerSearch"
                [cslServerSearch]="fetchProductionCards"
                [suggestions]="productionCardSearch.results()"
                [placeholder]="'Search Production Card'"
                [showClear]="true"
                [dropdown]="true"
                (onSelect)="assignmentProductionCards($event)"
                optionLabel="productionCardNumber"
              />
              @if (showStartButton()) {
                <p-button label="Start Cycle" severity="success" (click)="confirmStartCycle()" />
              }
            </div>
          </p-card>
        </p-panel>
      }

      <!-- Quality Control Section (AwaitingQA Only) -->
      @if (showQASection()) {
        <p-panel [header]="'DyeingMachineDetailsPage.QualityControl' | translateWF: 'Quality Control'">
          <p-card>
            <div class="flex flex-col gap-4">
              <!-- Approval Toggle -->
              <div class="flex items-center gap-4">
                <label class="font-medium"> {{ 'DyeingMachineDetailsPage.Status' | translateWF: 'Status' }} : </label>
                <p-selectButton
                  [options]="[
                    {
                      label: 'DyeingMachineDetailsPage.Approve' | translateWF: 'Approve',
                      value: true,
                    },
                    { label: 'DyeingMachineDetailsPage.Reject' | translateWF: 'Reject', value: false },
                  ]"
                  [(ngModel)]="isApproved"
                  optionLabel="label"
                  optionValue="value"
                />
              </div>

              <!-- Comments (shown when rejected) -->
              @if (showCommentsField()) {
                <div class="flex flex-col gap-2">
                  <label for="qaComments" class="font-medium">Comments (Required):</label>
                  <textarea
                    id="qaComments"
                    pInputTextarea
                    rows="4"
                    class="w-full"
                    [placeholder]="'DyeingMachineDetailsPage.RejectionComments' | translateWF: 'Enter Rejection Comments'"
                    [formControl]="qaComments"
                  ></textarea>
                </div>
              }

              <!-- Submit Button -->
              <div>
                <p-button
                  [label]="'DyeingDashboardMachineDetailsPage.SubmitQC' | translateWF: 'Submit Quality Control'"
                  [severity]="isApproved() != null ? 'primary' : 'danger'"
                  (click)="confirmSubmitQA()"
                  [disabled]="isApproved() == null"
                />
              </div>
            </div>
          </p-card>
        </p-panel>
      }

      <!-- Production Card Display -->
      @if (currentMachine()) {
        <app-card-machine [shortView]="false" [stateMachine]="currentMachine()!" [productionCardID]="productionCard()?.id ?? null" [canRedirect]="true" />
      }
    </div>
  </div>
</main>
